import React, {useState} from 'react';
import { useServices } from '../../../Data/Services';
import Checkboxes from './Checkboxes';
import AddService from '../../../Pages/PricingAndServices/Services/AddService';
import Button from '../../Button/Button';

const Services = (props) => {
    const {services, addService, isLoading} = useServices();

    const options = services ? services.map(s => ({value: s.type, label: s.title, group: s.category})): [{label: 'Loading...', value: ''}];
    const disabled = !services ? true : props.disabled;

    return <>
        <Checkboxes {...{options, disabled, ...props}}
            footer={<AddOther {...{services, addService}} />}
            noItems={isLoading ? 'Loading...' : 'No services, add one below'}
        />
    </>
}

const AddOther = ({services, addService}) => {
    const [adding, setAdding] = useState(false);

    return <p className="mt-2 pt-2 border-t">
        <Button theme="light"
            size="sm"
            icon="Plus"
            label="Add services"
            onClick={() => setAdding(true)}
            zeroMargin
        />

        <AddService isOpen={adding} setIsOpen={setAdding} services={services} addService={addService} showEditInfo />
    </p>
}

export default Services;
